import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';
import { passportStatusLabel } from '../../../pages/personal-info/qPage7/utils';
import { IRisk } from '../../../../types';

interface Props {
  showRisks: boolean;
  passportStatus?: string;
  passportExpiry?: string;
  passportExpected?: string;
  riskList?: IRisk['personalInfoRisk']['passportDetails'];
}

function PassportDetails({ showRisks, passportStatus, passportExpiry, passportExpected, riskList = [] }: Props) {
  return (
    <>
      {passportStatus && (
        <SummaryRow
          key="passportStatus"
          label="Passport Status"
          fullLabel="Do you currently have a passport?"
          value={passportStatusLabel(passportStatus)}
          isRisk={showRisks && riskList.includes(Q.PASSPORT_STATUS)}
        />
      )}
      {passportStatus === 'Yes' && passportExpiry && (
        <SummaryRow
          key="passportExpiry"
          label="Passport Expiry Date"
          value={passportExpiry}
          isDate={true}
          isRisk={showRisks && riskList.includes(Q.PASSPORT_EXPIRY)}
        />
      )}
      {passportStatus !== 'Yes' && passportExpected && (
        <SummaryRow
          key="passportExpected"
          label="Passport Expected"
          fullLabel="When do you expect to receive your passport?"
          value={passportExpected}
          isDate={true}
          isRisk={showRisks && riskList.includes(Q.PASSPORT_EXPECTED)}
        />
      )}
    </>
  );
}

export default PassportDetails;
